import * as React from "react";
const SvgChat = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.34768 10.6932L2.6665 11.9998V4.79984C2.6665 4.0531 2.6665 3.67973 2.81183 3.39452C2.93966 3.14363 3.14363 2.93966 3.39452 2.81183C3.67973 2.6665 4.0531 2.6665 4.79984 2.6665H9.8665C10.6132 2.6665 10.9866 2.6665 11.2718 2.81183C11.5227 2.93966 11.7267 3.14363 11.8545 3.39452C11.9998 3.67973 11.9998 4.0531 11.9998 4.79984V5.99984M13.3332 13.3332L11.8706 12.3581C11.6708 12.225 11.571 12.1584 11.4629 12.1112C11.367 12.0693 11.2665 12.0389 11.1635 12.0205C11.0474 11.9998 10.9273 11.9998 10.6872 11.9998H7.4665C6.71977 11.9998 6.3464 11.9998 6.06118 11.8545C5.8103 11.7267 5.60633 11.5227 5.4785 11.2718C5.33317 10.9866 5.33317 10.6132 5.33317 9.8665V8.13317C5.33317 7.38643 5.33317 7.01307 5.4785 6.72785C5.60633 6.47697 5.8103 6.27299 6.06118 6.14516C6.3464 5.99984 6.71977 5.99984 7.4665 5.99984H11.1998C11.9466 5.99984 12.3199 5.99984 12.6052 6.14516C12.856 6.27299 13.06 6.47697 13.1878 6.72785C13.3332 7.01307 13.3332 7.38643 13.3332 8.13317V13.3332Z",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgChat;
